import b from 'b_';
import { ComponentType } from 'react';

export const cnLessonView = b.with('lesson-view');

export interface LessonViewRegistry {
    AssignmentAddSchoolControl?: ComponentType<unknown>;
}
